import { Skeleton, Form, Input, Button, Divider } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { BottomButtons } from 'components/SharedComponents/BottomButtons/BottomButtons';
import gql from 'graphql-tag';
import { useAuthedMutationWithNotification } from 'utils/qlAuth';
import { StoryController_generateTitleAndDescription } from './buttons';

export const StorySeo = (props: { qStory: any; storyId: number }) => {
  const [StoryController_updateStory, updateStoryRes] = useAuthedMutationWithNotification(gql`
    mutation StoryController_updateStory($id: Int!, $config: JSON!) {
      StoryController_updateStory(id: $id, config: $config) {
        id
      }
    }
  `);

  const story = props.qStory.data?.StoryController_getStoryById || {};
  if (props.qStory.loading || !story) {
    return <Skeleton active />;
  }

  return (
    <>
      <StoryController_generateTitleAndDescription qStory={props.qStory} storyId={Number(props.storyId)} />
      <Divider />
      <Form
        layout="vertical"
        initialValues={story}
        onFinish={async values => {
          await StoryController_updateStory({ variables: { id: Number(props.storyId), config: values } });
        }}
      >
        <Form.Item label="Video title" name={`videoTitle`} key={`videoTitle`}>
          <Input name="videoTitle" />
        </Form.Item>
        <Form.Item label="Video description" name={`videoDescription`} key={`videoDescription`}>
          <TextArea rows={4} />
        </Form.Item>
        <BottomButtons>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </BottomButtons>
      </Form>
    </>
  );
};
